import React, { FC, useCallback } from 'react';

import { Pressable } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { ICartEntryType } from 'state/loyalty/in-restaurant-redemption';

import { BadgeAndIncrementor } from './badge-and-incrementor';
import {
  OfferItemDescription,
  OfferItemName,
  OfferItemPicture,
  RewardItemDescription,
  RewardItemName,
  RewardItemPicture,
} from './map-components';
import {
  InRestaurantRedemptionEntryContainer,
  InRestaurantRedemptionEntryContent,
  PictureAndDetails,
  RewardDetails,
  StyledIconX,
  WrapperName,
} from './reward-redemption.styled';
import { IRewardRedemptionItemProps, ViewComponentMapping } from './types';

const componentMapping: ViewComponentMapping = {
  [ICartEntryType.OFFER]: {
    ItemPicture: OfferItemPicture,
    ItemName: OfferItemName,
    ItemDescription: OfferItemDescription,
  },
  [ICartEntryType.LEGACY_OFFER]: {
    ItemPicture: OfferItemPicture,
    ItemName: OfferItemName,
    ItemDescription: OfferItemDescription,
  },
  [ICartEntryType.REWARD]: {
    ItemPicture: RewardItemPicture,
    ItemName: RewardItemName,
    ItemDescription: RewardItemDescription,
  },
};

export const RewardRedemptionItem: FC<React.PropsWithChildren<IRewardRedemptionItemProps>> = ({
  cartEntry,
  handleUpdateEntry,
  handleRemoveEntry,
}) => {
  const handleRemove = useCallback(() => {
    handleRemoveEntry(cartEntry);
  }, [cartEntry, handleRemoveEntry]);

  const { details, type } = cartEntry;
  const components = componentMapping[type];

  const { ItemPicture, ItemName, ItemDescription } = components;

  return (
    <InRestaurantRedemptionEntryContainer newUI={false}>
      <InRestaurantRedemptionEntryContent>
        <PictureAndDetails>
          <ItemPicture entryCartDetails={details} objectFitContain />

          <RewardDetails>
            <WrapperName>
              <ItemName entryCartDetails={details} />
            </WrapperName>
            <ItemDescription entryCartDetails={details} />

            <BadgeAndIncrementor cartEntry={cartEntry} handleUpdateEntry={handleUpdateEntry} />
          </RewardDetails>
        </PictureAndDetails>

        <Pressable
          onPress={handleRemove}
          padding={'$4'}
          accessibilityRole="button"
          accessibilityLabel={t('removeItem')}
          testID="remove-item"
        >
          <StyledIconX />
        </Pressable>
      </InRestaurantRedemptionEntryContent>
    </InRestaurantRedemptionEntryContainer>
  );
};
